import { SocialDistributionState } from './types'

const state = (): SocialDistributionState => ({
  groups: {},
  items: {
    loading: false,
    value: [],
  },
  publishedGroup: null,
  options: {
    pasteText: '',
    pasteDate: '',
    pastePublishedNow: undefined,
  },
})

export default state
